<template>
    <div v-if="componentData" class="small-wrapper content-intro__holder">
        <h2 v-if="componentData.introTitle" v-html="componentData.introTitle" ></h2>
        <p v-if="componentData.Description" v-html="componentData.Description"></p>
    </div>
    
</template>

<script lang="ts">

import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;
        console.log(props.componentData)

        return {
            homeurl
        };
    }
})

</script>
